// extracted by mini-css-extract-plugin
export default {"datosContainer":"general-data-form_styles_component_datosContainer__je0EW","apellidosContainer":"general-data-form_styles_component_apellidosContainer__7Tt0W"};